import { render, staticRenderFns } from "./CreateOfferDialog.vue?vue&type=template&id=ef66bbc8"
import script from "./CreateOfferDialog.vue?vue&type=script&lang=ts"
export * from "./CreateOfferDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateOfferDialog.vue?vue&type=style&index=0&id=ef66bbc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports